import Web3 from "web3";
//get thr browser's web 3 provider
export const web3 = new Web3(window.web3.currentProvider);